<form [formGroup]="endpointSearchForm" (ngSubmit)="onSubmit($event)" class="search-form">
  <div class="row align-items-center">
    <div class="form-group col-4">
      <input type="text" id="keyword" class="form-control form-control-md" placeholder="Search Keyword" formControlName="keyword">
    </div>
    <div class="form-group col-4">
      <ng-select [items]="myProjects" [attr.data-items]="myProjects | customList:'name'" [attr.data-locator]="'project-filter'" [attr.data-value]="myProjects | customList:endpointSearchForm.value.projectIds : 'name'" class="custom-select-md" bindLabel="name" bindValue="id" placeholder="Select project" [multiple]="true" [searchable]="true" formControlName="projectIds">
        <ng-template ng-option-tmp let-item="item">
          <div title="{{item.name}}" class="text-truncate">{{item.name}}</div>
        </ng-template>
      </ng-select>
    </div>
    <div class="form-group col-4" *ngIf="!mobileTestCase">
      <ng-select [attr.data-items]="endpointTypes" [attr.data-locator]="'endpointTypes-filter'" [attr.data-value]="endpointSearchForm.value.endPointType" [items]="endpointTypes" class="custom-select-md" bindLabel="name" bindValue="id" placeholder="Select endpoint type" formControlName="endPointType">
        <ng-option [value]="">Select</ng-option>
      </ng-select>
    </div>
  </div>
  <div class="row align-items-center">
    <div class="form-group col-4">
        <input type="text" id="locator-name" class="form-control form-control-sm" formControlName="updatedBy"
          placeholder="Search Updated By" />
      </div>
      <div class="form-group col-4">
        <input type="text" id="locator-name" class="form-control form-control-sm" formControlName="createdBy"
          placeholder="Search Created By" />
      </div>
      <div class="form-group col-4">
        <div style="display: flex;">
          <ng-select class="custom-style" id="locator-component" formControlName="sortBy"
            [items]="endpointSortList" bindLabel="name" bindValue="id" placeholder="Select Sort Option"
            [searchable]="true" style="width: 95%;" [clearable]="false">
          </ng-select>
          <i class="fas fa-sort-amount-up-alt" style="font-size: large; margin: 5px 5px;"
            *ngIf="endpointSortOrder === 'ASC'" ngbTooltip="Change the sort direction"
            (click)="updateSortOrder('DESC')"></i>
          <i class="fas fa-sort-amount-down-alt" style="font-size: large; margin: 5px 5px;"
            *ngIf="endpointSortOrder === 'DESC'" ngbTooltip="Change the sort direction"
            (click)="updateSortOrder('ASC')"></i>
        </div>
    </div>
  </div>
  <div class="row justify-content-start col-12 py-2 mb-2 align-items-center">
    <div class="form-check form-check-inline" *ngIf="projectConfiguration !== 'PLAYWRIGHT'">
      <input class="form-check-input" type="checkbox" formControlName="certified" id="certified">
      <label class="form-check-label" for="certified">Certified</label>
    </div>
    <div class="form-check form-check-inline">
      <input class="form-check-input" type="checkbox" id="src-subflow" formControlName="subFlow">
      <label class="form-check-label" for="src-subflow">Sub flow</label>
    </div>
    <div class="form-row ">
      <div class="pl-2">
        <button type="submit" class="btn search-btn btn-primary btn-sm" name="button">Search</button>
      </div>
      <div>
        <button (click)="onClear()" class="btn btn-sm btn-warning ml-2">Clear</button>
      </div>
    </div>
  </div>
</form>